import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation('webhook')
  return (
    <>
      <Grid justify="space-between" align="center" gutter={0.8}>
        <Col>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('title')}
          </Title>
        </Col>
      </Grid>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
